import React, { useState } from "react"; // ✅ this imports useState
import MainTitle from "../../muiHome/mainTitle";
import {
  Card,
  Grid,
  CardMedia,
  Dialog,
  DialogContent,
  IconButton,
  DialogTitle,
  Typography, // ✅ this fixes Typography error
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


const ConsumerAwarenessProgramme = () => {
  const [openImg, setOpenImg] = useState(false);
  const [previewImg, setPreviewImg] = useState('');

  const handleImgPreview = (img) => {
    setOpenImg(true);
    setPreviewImg(img);
  };

 const items = [
  { img: "/assets/img/SOL/event/event1_mg24.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg25.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg26.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg27.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg28.jpg" }, 
  { img: "/assets/img/SOL/event/event1_mg29.jpg" }, 
    { img: "/assets/img/SOL/event/event1_mg30.jpg" }, 
];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <MainTitle title="Consumer Awareness Programme" />
      </Grid>

      <Grid item xs={12}>
        <Typography fontSize="14px" fontFamily="sans-serif">
          <p>Date: 31st January 2025</p>
          <p>Organized By: School of Law, MVN University</p>
          <p>Theme: "Cyber Laws and Consumer Rights in the Digital Age"</p> 

          <ul>
              <li>	 	To create awareness about cyber laws and digital rights.</li>
              <li>	 To educate students on cyber crimes and precautionary measures.</li>
              <li>	 	To discuss potential risks associated with internet usage.</li>
              <li>	 To provide a platform for students to interact with telecom service providers and address their concerns regarding SIM-related issues.</li>
              
          </ul>
        </Typography>
      </Grid>

      {items.map((item, index) => (
  <Grid item xs={3} textAlign="center" key={index}>
    <Card
      sx={{
        height: "300px",
        padding: "10px",
        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
        borderRadius: "10px",
        cursor: "pointer",
      }}
      onClick={() => handleImgPreview(item.img)}
    >
      <CardMedia
        component="img"
        height="100%"
        image={item.img}
        alt="Event"
        style={{ height: "100%", width: "100%", objectFit: "contain" }}
      />
    </Card>
  </Grid>
))}

      <Dialog open={openImg} onClose={() => setOpenImg(false)}>
        <DialogTitle>
          <IconButton
            edge="end"
            onClick={() => setOpenImg(false)}
            aria-label="close"
            sx={{
              position: 'absolute',
              color: '#000',
              top: 0,
              right: 25
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img src={previewImg} height="100%" width="auto" alt="Preview" />
        </DialogContent>
      </Dialog>
    </Grid>
  );
};

export default ConsumerAwarenessProgramme;
